import { useEffect, useRef, useState } from 'react'

export function UploadOverlay() {
  const overlayRef = useRef<HTMLDivElement>(null)
  const [active, setActive] = useState(false)
  const dragCounterRef = useRef(0)

  useEffect(() => {
    const container = overlayRef.current?.parentElement
    if (!container)
      return

    function hasFiles(e: DragEvent): boolean {
      return Array.from(e.dataTransfer?.types ?? []).includes('Files')
    }

    const ctrl = new AbortController()
    // eslint-disable-next-line react/web-api-no-leaked-event-listener
    container.addEventListener('dragenter', (e) => {
      if (!hasFiles(e as DragEvent))
        return
      dragCounterRef.current++
      if (dragCounterRef.current === 1)
        setActive(true)
    }, ctrl)
    // eslint-disable-next-line react/web-api-no-leaked-event-listener
    container.addEventListener('dragleave', (e) => {
      if (!hasFiles(e as DragEvent))
        return
      dragCounterRef.current--
      if (dragCounterRef.current <= 0) {
        dragCounterRef.current = 0
        setActive(false)
      }
    }, ctrl)

    container.addEventListener('drop', () => {
      dragCounterRef.current = 0
      setActive(false)
    }, { capture: true, signal: ctrl.signal })

    return () => {
      ctrl.abort()
    }
  }, [])

  return (
    <div ref={overlayRef} className={`tiptap-upload-overlay${active ? ' is-active' : ''}`}>
      <div className="upload-overlay-inner">
        <span className="upload-overlay-label">Drop files to upload</span>
      </div>
    </div>
  )
}
